import React, { Component } from 'react';
import { translate } from 'react-i18next';

import Button from 'components/Button/Button';

import './CompareSelector.css';

declare var CONFIGURATIONS;

class CompareSelector extends Component {

  render() {
    const { selected, fullFotograms, getFlightOfFotogram, openComparator } = this.props;
    const fotograms = fullFotograms.filter((item) => {
      return selected.indexOf(item.properties[CONFIGURATIONS.fotogram_attr]) > -1;
    });

    const flights = fotograms.map((f) => {
      return getFlightOfFotogram(f.properties[CONFIGURATIONS.fotogram_attr]);
    });

    return (
      <React.Fragment>
        <div className='compareSelectorModalContainer row'>
          <table>
            { fotograms.length === 2 ?
              <tbody>
                <tr>
                  <th>Posición</th>
                  <th>Fotograma</th>
                </tr>
                <tr>
                  <td>
                    <span className='icon-columns-reverse'></span>
                  </td>
                  <td>
                    <select id='selectFotogram1' value={fotograms[0][CONFIGURATIONS.fotogram_attr]}>
                      <option value={fotograms[0].properties[CONFIGURATIONS.fotogram_attr]}>{`${flights[0].innerShortTitle} - ${fotograms[0].properties[CONFIGURATIONS.fotogram_attr]}`}</option>
                      <option value={fotograms[1].properties[CONFIGURATIONS.fotogram_attr]}>{`${flights[1].innerShortTitle} - ${fotograms[1].properties[CONFIGURATIONS.fotogram_attr]}`}</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className='icon-columns'></span>
                  </td>
                  <td>
                    <select id='selectFotogram2' value={fotograms[1][CONFIGURATIONS.fotogram_attr]}>
                      <option value={fotograms[1].properties[CONFIGURATIONS.fotogram_attr]}>{`${flights[1].innerShortTitle} - ${fotograms[1].properties[CONFIGURATIONS.fotogram_attr]}`}</option>
                      <option value={fotograms[0].properties[CONFIGURATIONS.fotogram_attr]}>{`${flights[0].innerShortTitle} - ${fotograms[0].properties[CONFIGURATIONS.fotogram_attr]}`}</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            : fotograms.length === 3 ?
              <tbody>
                <tr>
                  <th>Posición</th>
                  <th>Fotograma</th>
                </tr>
                <tr>
                  <td>
                    <span className='icon-columns-3'></span>
                  </td>
                  <td>
                    <select id='selectFotogram1' defaultValue={fotograms[0][CONFIGURATIONS.fotogram_attr]}>
                      <option value={fotograms[0].properties[CONFIGURATIONS.fotogram_attr]}>{`${flights[0].innerShortTitle} - ${fotograms[0].properties[CONFIGURATIONS.fotogram_attr]}`}</option>
                      <option value={fotograms[1].properties[CONFIGURATIONS.fotogram_attr]}>{`${flights[1].innerShortTitle} - ${fotograms[1].properties[CONFIGURATIONS.fotogram_attr]}`}</option>
                      <option value={fotograms[2].properties[CONFIGURATIONS.fotogram_attr]}>{`${flights[2].innerShortTitle} - ${fotograms[2].properties[CONFIGURATIONS.fotogram_attr]}`}</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className='icon-columus-2'></span>
                  </td>
                  <td>
                    <select id='selectFotogram2' defaultValue={fotograms[1][CONFIGURATIONS.fotogram_attr]}>
                      <option value={fotograms[1].properties[CONFIGURATIONS.fotogram_attr]}>{`${flights[1].innerShortTitle} - ${fotograms[1].properties[CONFIGURATIONS.fotogram_attr]}`}</option>
                      <option value={fotograms[0].properties[CONFIGURATIONS.fotogram_attr]}>{`${flights[0].innerShortTitle} - ${fotograms[0].properties[CONFIGURATIONS.fotogram_attr]}`}</option>
                      <option value={fotograms[2].properties[CONFIGURATIONS.fotogram_attr]}>{`${flights[2].innerShortTitle} - ${fotograms[2].properties[CONFIGURATIONS.fotogram_attr]}`}</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className='icon-columns-1'></span>
                  </td>
                  <td>
                    <select id='selectFotogram3' defaultValue={fotograms[2][CONFIGURATIONS.fotogram_attr]}>
                      <option value={fotograms[2].properties[CONFIGURATIONS.fotogram_attr]}>{`${flights[2].innerShortTitle} - ${fotograms[2].properties[CONFIGURATIONS.fotogram_attr]}`}</option>
                      <option value={fotograms[0].properties[CONFIGURATIONS.fotogram_attr]}>{`${flights[0].innerShortTitle} - ${fotograms[0].properties[CONFIGURATIONS.fotogram_attr]}`}</option>
                      <option value={fotograms[1].properties[CONFIGURATIONS.fotogram_attr]}>{`${flights[1].innerShortTitle} - ${fotograms[1].properties[CONFIGURATIONS.fotogram_attr]}`}</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            : fotograms.length === 4 ?
              <tbody>
                <tr>
                  <th>Posición</th>
                  <th>Fotograma</th>
                </tr>
                <tr>
                  <td>
                    <span className='icon-th-large-1'></span>
                  </td>
                  <td>
                    <select id='selectFotogram1' defaultValue={fotograms[0][CONFIGURATIONS.fotogram_attr]}>
                      <option value={fotograms[0].properties[CONFIGURATIONS.fotogram_attr]}>{`${flights[0].innerShortTitle} - ${fotograms[0].properties[CONFIGURATIONS.fotogram_attr]}`}</option>
                      <option value={fotograms[1].properties[CONFIGURATIONS.fotogram_attr]}>{`${flights[1].innerShortTitle} - ${fotograms[1].properties[CONFIGURATIONS.fotogram_attr]}`}</option>
                      <option value={fotograms[2].properties[CONFIGURATIONS.fotogram_attr]}>{`${flights[2].innerShortTitle} - ${fotograms[2].properties[CONFIGURATIONS.fotogram_attr]}`}</option>
                      <option value={fotograms[3].properties[CONFIGURATIONS.fotogram_attr]}>{`${flights[3].innerShortTitle} - ${fotograms[3].properties[CONFIGURATIONS.fotogram_attr]}`}</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className='icon-th-large-2'></span>
                  </td>
                  <td>
                    <select id='selectFotogram2' defaultValue={fotograms[1][CONFIGURATIONS.fotogram_attr]}>
                      <option value={fotograms[1].properties[CONFIGURATIONS.fotogram_attr]}>{`${flights[1].innerShortTitle} - ${fotograms[1].properties[CONFIGURATIONS.fotogram_attr]}`}</option>
                      <option value={fotograms[0].properties[CONFIGURATIONS.fotogram_attr]}>{`${flights[0].innerShortTitle} - ${fotograms[0].properties[CONFIGURATIONS.fotogram_attr]}`}</option>
                      <option value={fotograms[2].properties[CONFIGURATIONS.fotogram_attr]}>{`${flights[2].innerShortTitle} - ${fotograms[2].properties[CONFIGURATIONS.fotogram_attr]}`}</option>
                      <option value={fotograms[3].properties[CONFIGURATIONS.fotogram_attr]}>{`${flights[3].innerShortTitle} - ${fotograms[3].properties[CONFIGURATIONS.fotogram_attr]}`}</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className='icon-th-large-3'></span>
                  </td>
                  <td>
                    <select id='selectFotogram3' defaultValue={fotograms[2][CONFIGURATIONS.fotogram_attr]}>
                      <option value={fotograms[2].properties[CONFIGURATIONS.fotogram_attr]}>{`${flights[2].innerShortTitle} - ${fotograms[2].properties[CONFIGURATIONS.fotogram_attr]}`}</option>
                      <option value={fotograms[0].properties[CONFIGURATIONS.fotogram_attr]}>{`${flights[0].innerShortTitle} - ${fotograms[0].properties[CONFIGURATIONS.fotogram_attr]}`}</option>
                      <option value={fotograms[1].properties[CONFIGURATIONS.fotogram_attr]}>{`${flights[1].innerShortTitle} - ${fotograms[1].properties[CONFIGURATIONS.fotogram_attr]}`}</option>
                      <option value={fotograms[3].properties[CONFIGURATIONS.fotogram_attr]}>{`${flights[3].innerShortTitle} - ${fotograms[3].properties[CONFIGURATIONS.fotogram_attr]}`}</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className='icon-th-large-4'></span>
                  </td>
                  <td>
                    <select id='selectFotogram4' defaultValue={fotograms[3][CONFIGURATIONS.fotogram_attr]}>
                      <option value={fotograms[3].properties[CONFIGURATIONS.fotogram_attr]}>{`${flights[3].innerShortTitle} - ${fotograms[3].properties[CONFIGURATIONS.fotogram_attr]}`}</option>
                      <option value={fotograms[0].properties[CONFIGURATIONS.fotogram_attr]}>{`${flights[0].innerShortTitle} - ${fotograms[0].properties[CONFIGURATIONS.fotogram_attr]}`}</option>
                      <option value={fotograms[1].properties[CONFIGURATIONS.fotogram_attr]}>{`${flights[1].innerShortTitle} - ${fotograms[1].properties[CONFIGURATIONS.fotogram_attr]}`}</option>
                      <option value={fotograms[2].properties[CONFIGURATIONS.fotogram_attr]}>{`${flights[2].innerShortTitle} - ${fotograms[2].properties[CONFIGURATIONS.fotogram_attr]}`}</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            : null }
          </table>
        </div>
        <div className='compareSelectorModalButtonsContainer row'>
          <Button text={'Aceptar'} active={true} onClick={openComparator} />
        </div>
      </React.Fragment>
    );
  }
}

export default translate()(CompareSelector);
